import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/Iterator.html
 * @constructor
 * @private
 */
var Iterator = /*#__PURE__*/function () {
  function Iterator() {
    _classCallCheck(this, Iterator);
  }
  _createClass(Iterator, [{
    key: "hasNext",
    /**
       * Returns true if the iteration has more elements.
       * @return {boolean}
       */
    value: function hasNext() {}
    /**
       * Returns the next element in the iteration.
       * @return {Object}
       */
  }, {
    key: "next",
    value: function next() {}
    /**
       * Removes from the underlying collection the last element returned by the
       * iterator (optional operation).
       */
  }, {
    key: "remove",
    value: function remove() {}
  }]);
  return Iterator;
}();
export { Iterator as default };